// F10 (2026-05-16 perf audit): memoization key for pushPlan().
//
// MapView.pushPlan() early-returns when the key matches the previous push.
// Extracted to its own module so a unit test can exercise it without
// dragging in the React/MapLibre/DOM dependencies of MapView.tsx.
//
// Hash inputs:
//   - activeLegIndex (active leg paint state)
//   - route.length    (waypoint count)
//   - per-point: ident, lat/lon at toFixed(6) (~10cm), every procedureTag
//     flag that affects rendering or geometry (FAF/MAP/IAF/missed/hold/
//     synthetic/placeholder/legType/altitude constraint)
//
// A stale key is harmless (we just push the same frame again); a wrong
// collision is harmless too (worst case we skip one redundant push and
// the next mutation fixes it).

export interface PlanMemoRoutePoint {
  ident: string;
  lat: number;
  lon: number;
  procedureTag?: Record<string, unknown> | null;
}

export function computePlanMemoKey(
  route: ReadonlyArray<PlanMemoRoutePoint>,
  activeLegIndex: number,
): string {
  return `${activeLegIndex}|${route.length}|` + route.map((p) => {
    const t = p.procedureTag;
    return [
      p.ident,
      p.lat.toFixed(6),
      p.lon.toFixed(6),
      t ? `t:${t.routeType ?? ''}:${t.isFaf ? 1 : 0}:${t.isMap ? 1 : 0}:${t.isIaf ? 1 : 0}:${t.isMissedApproach ? 1 : 0}:${t.isHoldingPattern ? 1 : 0}:${t.holdInboundCourse ?? ''}:${t.synthetic ? 1 : 0}:${t.placeholder ? 1 : 0}:${t.legType ?? ''}:${t.altitudeConstraint ?? ''}:${t.altitude ?? ''}:${t.altitude2 ?? ''}` : '',
    ].join(',');
  }).join('|');
}
